<script setup lang="ts">
import { type NotivueItem } from 'notivue';
import BaseToast, { type NotivueItemProps } from './BaseToast.vue';

interface Props {
  item: NotivueItem<NotivueItemProps>;
}

defineProps<Props>();
</script>

<template>
  <BaseToast :item="item">
    <template #icon>
      <span :class="{ 'h-full': !item.title }" class="flex items-center justify-center rounded-md">
        <IconifyIcon
          icon="mingcute:loading-line"
          class="size-6 animate-spin text-brand-primary"
        ></IconifyIcon>
      </span>
    </template>
    <template #content>
      <h3 v-if="item.title" class="mb-1 text-base font-medium leading-4">
        {{ item.title }}
      </h3>
      <p
        :class="{ 'font-medium !text-brand-primary-dark': !item.title }"
        class="text-sm text-semantic-link-secondary"
        :role="item.ariaRole"
        :aria-live="item.ariaLive"
        v-safe-html="item.message"
      />
    </template>
  </BaseToast>
</template>

<style scoped lang="scss"></style>
